import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip';
import styled, { createGlobalStyle } from 'styled-components';
import * as colors from '../config/colors';

export default createGlobalStyle`
*{
  margin: 0;
  padding: 0;
  outline: none;
  box-sizing: border-box;
}

button, input, select, textarea {
  font-family: inherit;
}

body{
  font-family: 'Roboto', sans-serif;
  background: #fff;
  color: ${colors.primaryDarkColor};
}

html, body, #root {
  height: 100%;
  background: #fff;
}

button{
  cursor: pointer;
  background: ${colors.primaryColor};
  border: none;
  color: #fff;
  border-radius: 4px;
  font-weight: 700;
}

a{
  text-decoration: none;
  color: ${colors.primaryColor};
}

ul{
  list-style: none;
}

header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #333;
  color: #fff;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
}

body .Toastify .Toastify__toast-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 100vw;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

body .Toastify .Toastify__toast-container .Toastify__toast--success {
  background: ${colors.successColor};
  color: #000;
  font-weight: 700;
  border-radius: 5px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 1);
  padding: 1rem;
  text-align: center;
  z-index: 9999;
  pointer-events: auto;
}

body .Toastify .Toastify__toast-container .Toastify__toast--error {
  background: ${colors.errorColor};
  color: #000;
  font-weight: 700;
  border-radius: 5px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 1);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

body .Toastify .Toastify__toast-container .Toastify__toast--info {
  background: ${colors.infoColor};
  color: #000;
  font-weight: 700;
  border-radius: 5px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 1);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const Container = styled.section`
  max-width: 100%;
  background: #e6e8e6;
  margin-top: 2rem !important;
  margin-left: 6rem !important;
`;

export const ContainerAlternative = styled.section`
  max-width: 100%;
  margin-left: 6rem !important;
  background: #e6e8e6;
`;

export const Body = styled.div`
  margin-left: 3rem;
  margin-right: 3rem;
`;

export const Header = styled.div`
  background: #233d4d;
  color: #fff;
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`;

export const CustomTooltip = styled(Tooltip)`
  background: #333;
  color: #000;
  font-weight: 700;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
